module.exports = __webpack_public_path__ + "img/speaker-PatrickKluivert.8419c89a.png";